import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import { crearCliente } from '../../../actions/clientes';
import { setAlert } from '../../../actions/alert';

const AgregarClienteModal = ({ show, onHide, onClose, onSuccess }) => {
    const dispatch = useDispatch();

    const [nombre, setNombre] = useState('');
    const [correo, setCorreo] = useState('');
    const [telefono, setTelefono] = useState('');
    const [rfc, setRfc] = useState('');
    const [saving, setSaving] = useState(false);

    const closeHandler = typeof onClose === 'function' ? onClose : onHide;

    useEffect(() => {
        if (!show) return;

        setNombre('');
        setCorreo('');
        setTelefono('');
        setRfc('');
        setSaving(false);

        const prevOverflow = document.body.style.overflow;
        const prevPaddingRight = document.body.style.paddingRight;

        document.body.classList.add('modal-open');
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = prevPaddingRight;

        return () => {
            document.body.classList.remove('modal-open');
            document.body.style.overflow = prevOverflow;
            document.body.style.paddingRight = prevPaddingRight;
        };
    }, [show]);

    const disabled = useMemo(() => {
        return saving || nombre.trim().length === 0;
    }, [saving, nombre]);

    const onGuardar = async () => {
        const n = (nombre || '').trim();
        if (!n) {
            dispatch(setAlert('El nombre es requerido', 'danger'));
            return;
        }

        setSaving(true);
        const ok = await dispatch(crearCliente({
            nombre: n,
            correo: (correo || '').trim(),
            telefono: (telefono || '').trim(),
            rfc: (rfc || '').trim()
        }));
        setSaving(false);

        if (!ok) return;

        if (typeof onSuccess === 'function') {
            await onSuccess();
        } else if (typeof closeHandler === 'function') {
            closeHandler();
        }
    };

    if (!show) return null;

    return (
        <>
            <div
                className="modal fade show"
                role="dialog"
                aria-modal="true"
                tabIndex="-1"
                style={{ display: 'block', zIndex: 1055 }}
            >
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Agregar cliente</h5>
                            <button type="button" className="btn-close" onClick={closeHandler} />
                        </div>

                        <div className="modal-body">
                            <div className="row g-3">
                                <div className="col-12">
                                    <div className="form-floating">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="nuevo-cliente-nombre"
                                            placeholder="Nombre"
                                            value={nombre}
                                            onChange={(e) => setNombre(e.target.value)}
                                            autoFocus
                                            autoComplete="off"
                                        />
                                        <label htmlFor="nuevo-cliente-nombre">Nombre</label>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="form-floating">
                                        <input
                                            type="email"
                                            className="form-control"
                                            id="nuevo-cliente-correo"
                                            placeholder="Correo"
                                            value={correo}
                                            onChange={(e) => setCorreo(e.target.value)}
                                            autoComplete="off"
                                        />
                                        <label htmlFor="nuevo-cliente-correo">Correo</label>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="form-floating">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="nuevo-cliente-telefono"
                                            placeholder="Teléfono"
                                            value={telefono}
                                            onChange={(e) => setTelefono(e.target.value)}
                                            autoComplete="off"
                                        />
                                        <label htmlFor="nuevo-cliente-telefono">Teléfono</label>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-floating">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="nuevo-cliente-rfc"
                                            placeholder="RFC"
                                            value={rfc}
                                            onChange={(e) => setRfc(e.target.value)}
                                            autoComplete="off"
                                        />
                                        <label htmlFor="nuevo-cliente-rfc">RFC</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={closeHandler} disabled={saving}>
                                Cancelar
                            </button>
                            <button
                                type="button"
                                className="btn btn-success"
                                disabled={disabled}
                                onClick={onGuardar}
                            >
                                Guardar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="modal-backdrop fade show"
                style={{ zIndex: 1050 }}
                onClick={closeHandler}
            />
        </>
    );
};

export default AgregarClienteModal;
